import React, { type ReactNode } from 'react';
import { Flex, Spin } from 'antd';

const LoadingSpin = ({ compact = false }: { compact?: boolean }): ReactNode => {
  return (
    <Flex
      align="center"
      justify="center"
      style={{ width: '100%', height: compact ? '100px' : '400px' }}
    >
      <Spin />
    </Flex>
  );
};

export default LoadingSpin;
